export default __webpack_public_path__ + "static/media/Systems Interface Inc.fed305ef.png";